import './style.scss';
import CalculatorInit from '../CalculatorInit';

const init = options => {
  const defaultCalculatorOptions = {
    ID: '61',
    format: 'json',
    calculatorType: 'DefaultCalculator',
    options: {
      deafault: {
        deadlinesDefault: [137189],
        academicLevelDefault: 1,
        pagesDefault: 1,
      },
    },
    callback: () => {
      document
        .querySelector('[data-calc-mini]')
        .removeChild(document.querySelector('[data-calc-mini]').querySelector('.Loader'));
    },
  };

  const calculatorOptions = {
    ...defaultCalculatorOptions,
    ...options,
  };

  CalculatorInit(calculatorOptions);
};

const DefaultCalculator = options => {
  init(options);
};

export default DefaultCalculator;
